

import { Component, Vue } from "vue-property-decorator";
import { MstMemberVO } from "@/views/biz/join/vo/join.vo";
import axios from "axios";
import MarketingReceiveAgreePop from "@/views/biz-kr/member/MarketingReceiveAgreePop.vue";
import Constants from "@/constants";
import CommonUtils from "@/common-utils";

@Component({ components: { MarketingReceiveAgreePop } })
export default class MemberInfo extends Vue {
  member: MstMemberVO = {} as MstMemberVO;

  emailId = "";
  emailAddress = "";
  selectEmailAddress = "";
  checkPassword = '';

  isMailing = false;
  showPop = false;

  get getMember() {
    return this.member;
  }

  // 이메일
  get getMemberEmail() {
    if (this.emailId) {
      this.member.memEmail = `${this.emailId}@${this.emailAddress}`;
    } else {
      this.member.memEmail = "";
    }

    if (this.selectEmailAddress) {
      this.member.memEmail = `${this.emailId}@${this.selectEmailAddress}`;
    }
    return this.member.memEmail;
  }

  save() {
    if (this.member) {
      if(this.member.oldPassword || this.member.newPassword || this.checkPassword) {
        if(CommonUtils.validatePassword(this.member.newPassword) == false) {
          // 비밀번호는 영어와 숫자 조합으로 8자 이상 16자 이하로 입력해야 합니다.
          return alert(this.$t('member-info.a0007').toString());
        }
        if(this.member.validatPreexistencePassword == 'Y'  &&!this.member.oldPassword) {
          //기존 비밀번호를 확인해주세요.
          return alert(this.$t('member-info.a0017').toString()); 
        }
        if(this.member.newPassword && this.member.newPassword != this.checkPassword) {
          // 비밀번호가 일치하지 않습니다.
          return alert(this.$t('member-info.a0005').toString());
        }        
      }
      if (this.getMemberEmail && Constants.REGEXP_EMAIL.test(this.getMemberEmail) == false) {
        // 이메일을 확인해주세요.
        return alert(this.$t("join.a0016"));
      }
      // 저장하시겠습니까?
      if (confirm(this.$t("common.c0002").toString()) == false) {
        return;
      }

      this.member.mailingType = this.isMailing ? "01" : "02";
      //TODO 수정 후 세션 업데이트 해줘야 함
      axios.put("/mypage/profile/member-info", this.member).then(() => {
        // 저장되었습니다.
        alert(this.$t("member-info.a0024"));
        //저장 후 로컬스토리지 삭제 및 다음 페이지 이동
        this.endMemberInfo();
      });
    }
  }

  //저장 후 로컬스토리지 삭제 및 다음 페이지 이동
  // 1. 로컬스토리지 삭제
  // 2. 세션아이디 (아이폰 앱 내 저장된..) 동기화
  // 3. 페이지 전환
  endMemberInfo() {
    // const userAgent = navigator.userAgent.toLowerCase();
    // if(window['ReactNativeWebView'] && userAgent.indexOf('iphone') > -1) {
    //   window["webViewBridge"].send("sessionChange", {}, null);
    // }

    const orderPaymentCd = CommonUtils.getLocalStorageObject(Constants.ORDER_PAYMENT_CD);
    if (orderPaymentCd) {
      // 로컬스토리지 지역변수 저장 후 로컬스토리지 삭제
      CommonUtils.removeLocalStorageObject(Constants.ORDER_PAYMENT_CD);
      this.$router.push({ name: "OrderPayment", params: { orderCd: orderPaymentCd } });
    } else {
      this.$router.push({ name: "Mypage" });
    }
  }

  realNameAuth(): void {
    // PC면 새창
    if(this.$isMobile == false) {
      window.open(`${CommonUtils.createStaticUrl(this, 'RealNameForm' )}?nextRouteName=MemberInfo`, "_blank", "width=762, height=800")
      return;
    } 

    this.$router.push({ name: "RealNameForm", params: { nextRouteName: "MemberInfo" } });
  }

  created() {
    if (window.opener) {
      window.opener.location.href = CommonUtils.createStaticUrl(this, 'MemberInfo');
      window.close();
      return;
    }

    axios
      .get("/mypage/profile/validation")
      .then((r) => {
        if (r.data) {
          this.member = r.data.member;
          if (this.member.memEmail) {
            const splitEmail = this.member.memEmail.split("@");
            this.emailId = splitEmail[0];
            this.emailAddress = splitEmail[1];
          }
          this.isMailing = this.member.mailingType == "01";
        }
      })
      .catch(() => {
        this.$router.push({ name: "MemberInfoConfirm" });
      });
  }
}
